<template>
  <v-autocomplete
    label="Itinerary"
    :items="items"
    item-text="reference"
    item-value="id"
    v-model="itinerary"
    @change="onChange"
    dense
    :outlined="$store.getters.localSettings('outlinedInputs')"
    autocomplete
  ></v-autocomplete>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
const ITIS = gql`
  query allItis($filter: ItineraryFilterType) {
    itineraries(filter: $filter) {
      edges {
        node {
          id
          reference
        }
      }
    }
  }
`;
export default {
  name: "itinerary-list-select",
  props: {
    value: {
      type: String,
      default: () => "",
    },
    domain: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      itinerary: this.value,
    };
  },

  computed: {
    items() {
      return this.itineraries
        ? this.itineraries.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    value(newVal) {
      this.itinerary = newVal;
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.itinerary);
    },
  },

  apollo: {
    itineraries: {
      query: ITIS,
      variables() {
        return this.domain != "" ? { filter: { domain: this.domain } } : null;
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/documents/ItineraryListSelect.vue